// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CObject_abstract } from './../abstract/SagaSchema/CObject_abstract';
export class CObject extends CObject_abstract {
  static formsProperties = {
    info: ['Kind', 'Identification', 'Make', 'Text']
  };
}
